import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, KeyValues5, KeyValueSet, LocalService, LocalWeightMachineName, PageKey, Status, Wrappers10 } from 'src/service/local.service';

@Component({
  selector: 'app-device-network-settings',
  templateUrl: './device-network-settings.component.html',
  styleUrl: './device-network-settings.component.scss'
})
export class DeviceNetworkSettingsComponent {
  lstSectionConfigKeys: string[] = ["table"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; deviceItems: KeyValues5[] = []; businessId: string; machineItems: KeyValues5[] = [];

  weightMachineItems: LocalWeightMachineName[] = []; printers: KeyValues5[];
  isShowInactive: boolean = false;

  maxBodyHeight = 0; tabs: KeyValueSet[] = []; selectedTab: string = '1';
  selectedDeviceId: string = ''; selectedDeviceTitle: string = ''; isOpenDevicePopup = false;
  selectedMachineId: string = ''; selectedMachineTitle: string = ''; isOpenMachinePopup = false;
  currentDeviceId: string = '';

  constructor(public localService: LocalService, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private router: Router) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.configurationManagementService.ensurePageActions(PageKey.DeviceNetworkSettings);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.businessId = routeParams.businessId;
      this.onInitiate();
    });
  }

  onInitiate() {
    this.onLoadTabs();
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onLoad() {
    switch (this.selectedTab) {
      case '1': {
        const curentDevice = this.localService.onGetCurrentDeviceSettingsOfBusiness();
        if (curentDevice) {
          this.currentDeviceId = curentDevice.Id;
        }
        this.configurationManagementService.getDeviceInfoSettings(this.businessId, !this.isShowInactive).subscribe(result => {
          this.deviceItems = result;
        });

        this.configurationManagementService.GetActiveLocalWeightMachineNamesByBusinessId(this.businessId).subscribe(result => {
          this.weightMachineItems = result;
        });

        this.configurationManagementService.getActiveLocalPrinterNamesMin(this.businessId).subscribe(result => {
          this.printers = result;
          this.printers.forEach(x => {
            x.v2 = [x.v1, x.v2].join(' / ');
          });
        });
      } break;
      case '2': {
        this.configurationManagementService.getLocalNetworkSettings(this.businessId, !this.isShowInactive).subscribe(result => {
          this.machineItems = result;
        });
      } break;
    }
  }

  onAction(index: number, key?: string) {
    switch (this.selectedTab) {
      case '1': {
        switch (index) {
          case 1: {
            this.selectedDeviceId = '';
            this.selectedDeviceTitle = "New Device";
            this.isOpenDevicePopup = true;
          } break;
          case 2: {
            const item = this.deviceItems.find(x => x.key == key);
            this.selectedDeviceId = key;
            this.selectedDeviceTitle = item?.v1 || 'N/A';
            this.isOpenDevicePopup = true;
          } break;
          case 3: {
            this.configurationManagementService.assignUserToDevice(this.businessId, this.userId, key).subscribe(result => {
              this.localService.showInformationByStatus(result.status);
              if (result.status == Status.Success) {
                let currentDeviceSettings = this.localService.getLastDeviceSettings(this.localService.loggedMember.loggedMember.content.v9);
                let item = currentDeviceSettings.find(x => x.key == this.businessId);
                item.value = result.id;
                this.currentDeviceId = key;
                this.localService.setLastDeviceSettings(this.localService.loggedMember.loggedMember.content.v9, currentDeviceSettings);
              }
            });
          } break;
        }
      } break;
      case '2': {
        switch (index) {
          case 1: {
            this.selectedMachineId = '';
            this.selectedMachineTitle = "New Machine";
            this.isOpenMachinePopup = true;
          } break;
          case 2: {
            const item = this.machineItems.find(x => x.key == key);
            this.selectedMachineId = key;
            this.selectedMachineTitle = item?.v1 || 'N/A';
            this.isOpenMachinePopup = true;
          } break;
        }break;
      }
    }
  }

  onLoadTabs() {
    this.tabs = [{
      key: '1',
      value: "UI Device Management"
    } as KeyValueSet,
    {
      key: '2',
      value: "Machines Settings (Printer / Weight Machine)"
    } as KeyValueSet];
  }

  onRoute(key: string) {
    this.router.navigate(['/device-menus' + this.localService.basicParamsString, this.businessId, key]);
  }
}
